module.exports = __webpack_public_path__ + "static/img/xcxCode.6e1ff69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xyd/index/xcxCode.png
// module id = 9/CS
// module chunks = 83